
<template>
  <el-table
    :data="services"
    :default-sort="{prop:'name', order:'ascending'}"
    stripe
    size="small"
  >
    <el-table-column type="expand">
      <template slot-scope="props">
        <ServicePeek :service="props.row" />
      </template>
    </el-table-column>
    <el-table-column
      prop="name"
      label="Name"
      sortable
      :formatter="row => $_.get(row, 'name', '-')"
    />
    <el-table-column
      prop="chainit"
      label="Service Code"
      sortable
      :formatter="row => $_.get(row, 'chainit', '-')"
    />
    <el-table-column
      prop="code"
      label="Carrier Service Code"
      sortable
      :formatter="row => $_.get(row, 'code', '-')"
    />
    <el-table-column
      prop="edi"
      label="Service Code for EDI"
      sortable
      :formatter="row => $_.get(row, 'edi', '-')"
    />
    <el-table-column
      prop="weight_max"
      label="Weight Limit"
      sortable
      :formatter="row => $_.get(row, 'weight_max', '-')+'kg'"
    />
    <el-table-column
      prop="volume_max"
      label="Volume Limit"
      sortable
      :formatter="row => $_.get(row, 'volume_max', '-')+'m3'"
    />
    <el-table-column
      prop="allow_dg"
      label="DG"
      sortable
      :formatter="row => $_.get(row, 'allow_dg') ? 'Yes' : 'No'"
    />
    <el-table-column
      label="Default Cubic"
      :formatter="row => $_.get(row, 'default_cubic', '-')"
    />
    <el-table-column
      label="Service Type"
      :formatter="row => $_.get(row, 'service_type.name', '-')"
    />
    <el-table-column
      v-if="canUpdate || canDelete"
      label="Actions"
      align="right"
    >
      <template slot-scope="scope">
        <el-button
          v-if="canUpdate"
          size="mini"
          @click.native="$emit('edit', scope.row)"
        >
          Edit
        </el-button>
        <el-button
          v-if="canDelete"
          size="mini"
          type="danger"
          @click.native="deleteService(scope.$index, scope.row)"
        >
          Delete
        </el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { UPDATE, DELETE } from '@/plugins/user'
import ServicePeek from '@/components/Application/Manage/Carriers/ServicesPeek'
export default {
  components: {
    ServicePeek
  },
  props: {
    services: {
      type: Array,
      required: true,
      default: null
    }
  },
  computed: {
    canUpdate () {
      return this.$user.can(UPDATE, 'carrier_service')
    },
    canDelete () {
      return this.$user.can(DELETE, 'carrier_service')
    }
  },
  methods: {
    deleteService (index, service) {
      this.$confirm('Are you sure to delete this service?', 'Delete', {
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        service.delete(builder => { builder.context = { resource: 'carrier', id: this.$route.params.carrierId } })
          .then(res => this.$message({ message: 'Successfully deleted', type: 'success' }))
          .finally(() => {
            this.isSaving = false
            this.$emit('refresh')
          })
      }).catch(() => {})
    }
  }
}
</script>
